import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Services from "@/pages/Services";

export const Route = createFileRoute("/en/services/")({
  head: () => buildRouteHead("/en/services"),
  component: Services,
});

